import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "relative" };
var _hoisted_2 = ["type", "value", "id", "placeholder"];
var _hoisted_3 = ["for"];
var _hoisted_4 = {
    key: 0,
    class: "ml-6 mt-1 h-6 text-feed-red text-10px font-bold"
};
import { ref, computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'InputText',
    props: {
        inputId: { type: String, required: false },
        label: { type: String, required: false, default: '' },
        value: { type: String, required: true },
        placeholder: { type: String, required: false, default: '' },
        validation: { type: Object, required: false, default: function () { } },
        required: { type: Boolean, required: false, default: false },
        isNumberOnly: { type: Boolean, required: false },
        isAlphanumericOnly: { type: Boolean, required: false },
        initialMessage: { type: String, required: false, default: '' },
    },
    emits: [
        'clearValue',
        'updateValue',
        'checkInputValue',
    ],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var errorMessage = ref(props.initialMessage);
        var inputType = computed(function () {
            return props.isNumberOnly ? 'tel' : 'text';
        });
        var changeCharacterFH = function (value) {
            return value
                .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
                return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
            })
                .replace(/　/g, ' ');
        };
        var clearValue = function () {
            return '';
        };
        var updateValue = function (v) {
            errorMessage.value = '';
            var _a = props.validation, maxLength = _a.maxLength, required = _a.required;
            if (maxLength && v.length > maxLength && maxLength != 0) {
                errorMessage.value = "".concat(maxLength, "\u6587\u5B57\u4EE5\u5185\u3067\u304A\u9858\u3044\u3057\u307E\u3059");
            }
            else if (required && /^\s+$/.test(v)) {
                errorMessage.value = 'スペースのみの登録できません';
            }
            emit('updateValue', { value: v, isValid: !errorMessage.value });
        };
        var checkInputValue = function (value) {
            var _a = props.validation, maxLength = _a.maxLength, required = _a.required;
            if (props.isNumberOnly) {
                value = changeCharacterFH(value);
            }
            if (props.required && value.trim().length == 0) {
                errorMessage.value = "".concat(props.label, "\u306F\u5FC5\u9808\u3067\u3059");
            }
            else if (required && /^\s+$/.test(value)) {
                errorMessage.value = 'スペースのみの登録できません';
            }
            else if (props.isNumberOnly && value.match(/[^0-9]+/)) {
                errorMessage.value = '数字のみ入力可能です';
            }
            else if (props.isAlphanumericOnly) {
                if (!value.match(/^[\x20-\x7e]*$/)) {
                    errorMessage.value = "\u534A\u89D2\u306E\u30ED\u30FC\u30DE\u5B57\u3067\u5165\u529B\u3057\u3066\u4E0B\u3055\u3044";
                }
            }
            emit('checkInputValue', { value: value, isValid: !errorMessage.value });
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("input", {
                    type: inputType.value,
                    value: __props.value,
                    onInput: _cache[0] || (_cache[0] = function ($event) { return (updateValue($event.target.value)); }),
                    onBlur: _cache[1] || (_cache[1] = function ($event) { return (checkInputValue($event.target.value)); }),
                    id: __props.inputId,
                    class: _normalizeClass(["floating-label p-6 w-full text-16px leading-none border border-grey-95 rounded", [!__props.value ? '' : 'value']]),
                    placeholder: __props.placeholder
                }, null, 42, _hoisted_2),
                _withDirectives(_createElementVNode("label", {
                    for: __props.inputId,
                    class: "px-2"
                }, [
                    _createElementVNode("span", null, _toDisplayString(__props.label), 1)
                ], 8, _hoisted_3), [
                    [_vShow, !__props.placeholder]
                ]),
                (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
